import { Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { InventoryPageQueryKeys } from '@Inventory/common/queryKeys';
import { MaterialIcon } from '@components';
import { useMemo, useState } from 'react';
import { useGetSavedQuery } from '@Inventory/services/savedQueryQueries';

export function SaveQueryButton() {
  const [queryParams, setQueryParams] = useSearchParams();

  const savedQueryId = useMemo(() => queryParams.get(InventoryPageQueryKeys.SavedQueryId), [queryParams]);
  const query = useMemo(() => queryParams.get(InventoryPageQueryKeys.Query), [queryParams]);

  const { savedQuery, isSavedQueryFetched } = useGetSavedQuery(savedQueryId || '');

  const canEditQuery = savedQuery ? savedQuery.query !== query : false;

  const handleOnClick = (queryParam: string) => {
    const newQueryParams = new URLSearchParams(queryParams);
    newQueryParams.set(queryParam, 'true');
    setQueryParams(newQueryParams);
  };

  if (!savedQueryId || !isSavedQueryFetched || !canEditQuery) {
    return (
      <Button size="small" variant="text" onClick={() => handleOnClick(InventoryPageQueryKeys.SaveQueryModalOpen)}>
        Save Access Scope
      </Button>
    );
  }

  return <AccessScopeActionDropdown handleOnClick={handleOnClick} />;
}

function AccessScopeActionDropdown({ handleOnClick }: { handleOnClick: (queryParam: string) => void }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const options = [
    {
      icon: 'save',
      label: 'Save Access Scope',
      onClick: () => handleOnClick(InventoryPageQueryKeys.SaveQueryModalOpen),
    },
    {
      icon: 'edit_square',
      label: 'Edit Access Scope',
      onClick: () => handleOnClick(InventoryPageQueryKeys.EditQueryModalOpen),
    },
  ];

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (action: () => void) => {
    action();
    handleClose();
  };

  return (
    <>
      <Button
        variant="text"
        onClick={handleClick}
        endIcon={<MaterialIcon weight={700} symbol={open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} />}
      >
        Save Access Scope
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        {options.map((option) => (
          <MenuItem key={option.label} onClick={() => handleSelect(option.onClick)} divider={false}>
            <Stack direction="row" spacing={0.5} alignItems={'center'}>
              <MaterialIcon symbol={option.icon} />
              <Typography variant="helperText">{option.label}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
